import React, { Component } from 'react'

import NaviIconMenu from './NaviIconMenu'

// 企業ユーザーの各画面共通ヘッダー。
// タイトル（左）＋ページ固有の操作ボタン（任意, children）＋インラインのアイコンメニュー（右）を並べる。
class PageHeader extends Component {
  render () {
    return (
      <section className='nav nav-page'>
        <div className='container'>
          <div className='row'>
            <div className='span5'>
              <header className='page-header'>
                <h3>{this.props.title}<br />
                  <small>{this.props.sub}</small>
                </h3>
              </header>
            </div>
            <div className='page-nav-options'>
              <div className='span11'>
                <NaviIconMenu inline history={this.props.history} />
                {this.props.children}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default PageHeader



// WEBPACK FOOTER //
// ./src/company_user/components/PageHeader.js